import { observer } from "mobx-react";
import * as React from "react";
import { BrandingIcon } from "../Icons/BrandingIcon";
import { DocumentsIcon } from "../Icons/DocumentsIcon";
import { FavouriteIcon } from "../Icons/FavouriteIcon";
import { LanguagesIcon } from "../Icons/LanguagesIcon";
import { MetaDataIcon } from "../Icons/MetaDataIcon";
import { MetaDataTranslateIcon } from "../Icons/MetaDataTranslateIcon";
import { PortalSettingsIcon } from "../Icons/PortalSettingsIcon";
import { ReaderIcon } from "../Icons/ReaderIcon";
import { RecentFilesIcon } from "../Icons/RecentFilesIcon";
import { SearchIcon } from "../Icons/SearchIcon";
import { StartIcon } from "../Icons/StartIcon";
import { SynchronisationIcon } from "../Icons/SynchronisationIcon";
import { UserIcon } from "../Icons/UserIcon";
import { AppStore } from "../Stores/AppStore";
import { Strings } from "../Stores/StringsStore";
import { Urls } from "../Urls";
import { Link } from "./Link";

interface IAppQuickNavigationProps {
	path: string;
}

@observer
export class AppQuickNavigation extends React.Component<IAppQuickNavigationProps, {}> {

	getClassName(path: string) {
		let currentPath = AppStore.previousPaths.length > 0 ? AppStore.previousPaths[AppStore.previousPaths.length - 1] : AppStore.history.location.pathname;
		let isPath: boolean;
		if (path === Urls.home) {
			isPath = currentPath === path;
		}
		else {
			isPath = currentPath.indexOf(path) > -1;
		}
		return isPath ? "current" : "";
	}

	render() {
		return <div className="app__quick">

			<div className="app-quicknav">

				<span className="app-quicknav__primary">
					<ul>
						<li className={this.getClassName(Urls.home)}>
							<Link to={Urls.home} useHistoryOverride={true} title={Strings.appNavigation.homeLinkText}>
								<StartIcon />
							</Link>
						</li>
						<li className={this.getClassName(Urls.search)}>
							<Link to={Urls.search} useHistoryOverride={true} title={Strings.appNavigation.searchDocumentsLinkText}>
								<SearchIcon />
							</Link>
						</li>
						<li className={this.getClassName(Urls.reader)}>
							<Link to={Urls.reader} useHistoryOverride={true} title={Strings.appNavigation.readerLinkText}>
								<ReaderIcon />
							</Link>
						</li>
						<li className={this.getClassName(Urls.favorites)}>
							<Link to={Urls.favorites} useHistoryOverride={true} title={Strings.appNavigation.favoriteLinkText}>
								<FavouriteIcon />
							</Link>
						</li>
						<li className={this.getClassName(Urls.recentFiles)}>
							<Link to={Urls.recentFiles} useHistoryOverride={true} title={Strings.appNavigation.recentFilesLinkText}>
								<RecentFilesIcon />
							</Link>
						</li>
						{AppStore.context.sessionDetails.isApp ? <li className={this.getClassName(Urls.sync)}>
							<Link to={Urls.sync} useHistoryOverride={true} title={Strings.appNavigation.syncLinkText}>
								<SynchronisationIcon />
							</Link>
						</li> : null}
					</ul>
				</span>

				<span className="app-quicknav__secondary">
					<ul>
						{AppStore.context.sessionDetails.isDocumentManager && !AppStore.context.sessionDetails.isApp ? <li className={this.getClassName(Urls.collections)}>
							<Link to={Urls.collections} useHistoryOverride={true} title={Strings.appNavigation.collectionsLinkText} disabled={!AppStore.isSystemOnline}>
								<DocumentsIcon />
							</Link>
						</li> : null}

						{AppStore.context.sessionDetails.isMetaDataManager && !AppStore.context.sessionDetails.isApp ? <li className={this.getClassName(Urls.metas)}>
							<Link to={Urls.metas} useHistoryOverride={true} title={Strings.appNavigation.metaDataLinkText} disabled={!AppStore.isSystemOnline}>
								<MetaDataIcon />
							</Link>
						</li> : null}

						{AppStore.context.sessionDetails.isMetaDataManager && !AppStore.context.sessionDetails.isApp ? <li className={this.getClassName(Urls.translation)}>
							<Link to={Urls.translation} useHistoryOverride={true} title={Strings.appNavigation.translationLinkText} disabled={!AppStore.isSystemOnline}>
								<MetaDataTranslateIcon />
							</Link>
						</li> : null}

						{AppStore.context.sessionDetails.isBrandingManager && !AppStore.context.sessionDetails.isApp ? <li className={this.getClassName(Urls.branding)}>
							<Link to={Urls.branding} useHistoryOverride={true} title={Strings.appNavigation.brandingSettingsLinkText} disabled={!AppStore.isSystemOnline}>
								<BrandingIcon />
							</Link>
						</li> : null}

						{AppStore.context.sessionDetails.isBrandingManager && !AppStore.context.sessionDetails.isApp ? <li className={this.getClassName(Urls.languages)}>
							<Link to={Urls.languages} useHistoryOverride={true} title={Strings.appNavigation.languageSettingsLinkText} disabled={!AppStore.isSystemOnline}>
								<LanguagesIcon />
							</Link>
						</li> : null}

						{AppStore.context.sessionDetails.isApp ? <li className={this.getClassName(Urls.portals)}>
							<Link to={Urls.portals} useHistoryOverride={true} title={Strings.appNavigation.portalSettingsLinkText}>
								<PortalSettingsIcon />
							</Link>
						</li> : null}
					</ul>
				</span>

			</div>

		</div>;
	}
}
